import { useContext, useEffect, useState } from "react";

import { MenuItem, TextField } from '@mui/material';

import AuthContext from "../../../../store/AuthContext";
import BuilderContext from '../../../../store/BuilderContext';

const BackgroundPosition = (props) => {

  const { blockId, propertyName, screenType, name = "" } = props;
  const authCtx     = useContext(AuthContext);
  const builderCtx  = useContext(BuilderContext);

  const { contentBlocks, updateContentBlocks, currentContentBlock, updateCurrentBlock } = builderCtx;


  const getCurrentBlockStyles = () => {
    switch ( screenType ) {
      case "mobile" :
        return currentContentBlock?.mobileStyling;
      break;
      case "horizontal":
        return currentContentBlock?.horizontalStyling;
      break;
      case "vertical":
        return currentContentBlock?.verticalStyling;
      break;
      default:
        return currentContentBlock?.styling;
      break;
    }
  }

  const currentBlockStyles = getCurrentBlockStyles();

  const currentBgPosition = currentBlockStyles?.backgroundPosition;

  // css image background-position property 
  const positions = [
    { value: 'top',    label: 'top'    },
    { value: 'bottom', label: 'bottom' },
    { value: 'left',   label: 'left'   },
    { value: 'right',  label: 'right'  },
    { value: 'center', label: 'center' },
  ];

  const [bgPosition, setBgPosition] = useState(currentBgPosition || "center");

  const handleChange = (e) => {
    setBgPosition(e.target.value);
  }

  useEffect(() => {

    let timer;
    if (bgPosition && bgPosition !== currentBgPosition) {
      timer = setTimeout(() => {
        updateContentBlocks(contentBlocks?.map(block => {
          if (block.id === blockId) {
            let payload = {
              id: blockId,
              value: bgPosition,
              screenType: props?.screenType
            }
            fetch(process.env.REACT_APP_API_URI + '/v3/admin/assessment/styling/backgroundPosition', {
              method: 'PUT', mode: 'cors',
              headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authCtx.token },
              body: JSON.stringify(payload),
            })
            .then(response => response.json())
            .then(data => {
              if(data.status === "success") {
                switch (screenType) {
                  case "mobile":
                    return {
                      ...block,
                      mobileStyling: {
                        ...block.mobileStyling,
                        backgroundPosition: bgPosition
                      }
                    };
                  case "horizontal":
                    return {
                      ...block,
                      horizontalStyling: {
                        ...block.horizontalStyling,
                        backgroundPosition: bgPosition
                      }
                    };
                  case "vertical":
                    return {
                      ...block,
                      verticalStyling: {
                        ...block.verticalStyling,
                        backgroundPosition: bgPosition
                      }
                    };
                  default:
                    return {
                      ...block,
                      styling: {
                        ...block.styling,
                        backgroundPosition: bgPosition
                      }
                    };
                }
              }
            }).catch((err) => {
              console.error("Failed to update backgroundPosition...", err);
            });

            return { ...block, styling: { ...block.styling, backgroundPosition: bgPosition, }, };
          } else return block;
        }))
      }, 1000);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };

  }, [authCtx.token, blockId, bgPosition]);

  // console.log("blockId", blockId);
  // console.log("bgPosition", bgPosition);

  return (
    <div className="backgroundimg tool">

      <div className="background-position">
        {props.deleteModal}
        <TextField className="position-unit styling-select" select variant="standard"
          InputProps={{ disableUnderline: true }}
          // placeholder={currentContentBlock?.styling?.backgroundPosition + ""} 
          value={bgPosition} onChange={handleChange} >
          {positions?.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </div>

    </div>
  )
}


export default BackgroundPosition;


